import { render, staticRenderFns } from "./item-scale.vue?vue&type=template&id=076bbf9e&scoped=true"
import script from "./item-scale.vue?vue&type=script&lang=js"
export * from "./item-scale.vue?vue&type=script&lang=js"
import style0 from "./item-scale.vue?vue&type=style&index=0&id=076bbf9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076bbf9e",
  null
  
)

export default component.exports